import { Checkbox, TableHead, TableRow } from "@material-ui/core";
import React from "react";
import StyledTableCell from "../../../styles/tableCell";

const TableHeadDistribution = ({
  onSelectAllClick,
  rowCount,
  numSelected,
  isDashboard,
  headCells,
}) => {
  return (
    <TableHead>
      <TableRow
        style={{
          borderBottom: "0.5px solid gray",
        }}
      >
        {!isDashboard && (
          <StyledTableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              color="primary"
              inputProps={{ "aria-label": "select all items" }}
            />
          </StyledTableCell>
        )}
        {headCells.map((headCell) => (
          <StyledTableCell
            key={headCell.id}
            align="center"
            padding={headCell.disablePadding ? "none" : "default"}
          >
            {headCell.label}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default TableHeadDistribution;
